<template>
    <article class="article">
        <p class="fwbd mt20 tc">点点会员服务协议</p>
        <p class="fwbd mt20">欢迎注册成为点点APP会员(以下简称“点点”或者平台方)，请您在注册前阅读本服务协议，勾选“我已经认真阅读并同意《点点会员服务协议》”，当您点击“同意”按钮即表示您确认本服务协议内容并自愿遵守本协议。</p>
        <p class="mt20">一、会员须知 </p>
        <p class="txin">1.  注册者资格</p>
        <p class="txin">您确认，在您完成注册程序或使用点点服务时，您应当是具备完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果。</p>
        <p class="txin">您可以在保山施甸长江村镇银行股份有限公司网站、APP以及相关微信服务号注册成为点点会员，但在接受或购买点点平台上展示的具体产品或服务时，您可能需要提供法律法规要求及该产品或服务所需的必要身份信息及资料。 </p>
        <p class="txin">2.  用户信息</p>
        <p class="txin">a). 在完成注册、激活或验证流程时，您应当按照相应页面的提示提供您的真实、准确、完整的身份信息及资料； </p>
        <p class="txin">b). 当您的身份信息及资料发生变化时，您应当及时进行更新。</p>
        <p class="txin">3.  隐私声明 </p>
        <p class="txin">您了解并同意，点点将按照《保山施甸长江村镇银行隐私声明》保护您的个人信息，保山施甸长江村镇银行股份有限公司将在公司网站上公布并有权不时修订《保山施甸长江村镇银行隐私声明》，《保山施甸长江村镇银行隐私声明》构成本协议的有效组成部分。 </p>
        <p class="txin">4.  账户安全</p>
        <p class="txin">a). 您应对您在点点的登录名和密码保密，且须对您在该登录名和密码下发生的所有活动（包括但不限于发布信息、网上点击同意或提交购买、接受各类产品或服务等）承担责任。</p>
        <p class="txin">b). 您了解并同意： 如发现任何人未经授权使用您的点点登录名和密码，您应当立即通知点点，授权点点经过必要身份识别措施后更改密码或作出其他应对措施。但点点不会对因您未能遵守本款规定而发生的任何损失负责。 </p>
        <p class="txin">5.  账户管理：除非有法律规定或司法裁判，否则您的登录名和密码不得以任何方式转让、赠与或继承。 </p>
        <p class="mt20">二、会员的权利和义务 </p>
        <p class="txin">1.  在遵守本服务协议的前提下，您将享有本网站提供的会员服务，并将收到点点平台发布的最新的优惠产品和服务的相关信息。</p>
        <p class="txin">2.  如您不愿意接受点点的信息，您有权要求点点停止向您发送产品和服务信息。 </p>
        <p class="txin">3.  在点点网站上使用点点服务过程中，您承诺遵守以下约定： </p>
        <p class="txin">a). 在使用点点服务过程中所有行为均遵守国家法律、法规等规范性文件，不违背社会公共利益或公共道德，不损害他人合法权益，不违反本协议； </p>
        <p class="txin">b). 在未经点点事先书面同意的情况下，不以复制、传播等任何方式使用点点网站上展示的资料、信息或数据。 </p>
        <p class="txin">4.  您了解并同意： </p>
        <p class="txin">a). 对于您在点点上发布的涉嫌违法或涉嫌侵犯他人合法权利或违反本协议的信息，点点有权不经通知您即予以删除； </p>
        <p class="txin">b). 对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任。 </p>
        <p class="mt20">三、责任免除 </p>
        <p class="txin">1.  您了解并同意，点点不对因下述任一情况而导致您的任何损害承担责任： </p>
        <p class="txin">a). 使用或未能使用点点的服务； </p>
        <p class="txin">b). 第三方未经批准使用您的账户或更改您的数据；</p>
        <p class="txin">c). 你接受或购买的发布在点点平台上的产品或服务条款或协议中约定的免责范围，以及约定的服务范围之外的损失。</p>
        <p class="txin">2.  在任何情况下，点点均不对由于信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，暴乱，起义，骚乱，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服务承担责任； </p>
        <p class="txin">3.  为了提高服务质量，点点可能暂停服务以调整或升级系统，点点需在网站公告暂停服务时间。在任何情况下，点点无须为暂停会员服务承担违约责责任。 </p>

        <p class="mt20">四、服务协议的修改、中止、终止和账户注销 </p>
        <p class="txin">1.  您了解并同意：点点在法律环境变化或业务发展需要时可能对本服务协议所做的修改，本服务协议如发生任何变动，点点将在网站上公示变动内容，如您不同意相应修改的，可以选择注销您的点点会员账户。 </p>

        <p class="txin">2.  您同意，出现以下情况时，点点有权不经事先通知地中止、终止向您提供部分或全部点点的会员服务，并注销您的账户（点点会员资格），且无须为此向您或任何第三方承担任何责任： </p>
        <p class="txin">a). 您在使用点点平台提供的服务期间存在违法行为或违反本协议和/或规则的行为的； </p>
        <p class="txin">b). 您提供的个人身份信息虚假或不真实或不完整或过期无效的； </p>
        <p class="txin">c). 以他人名义注册为点点会员的； </p>
        <p class="txin">d). 未经有效许可使用他人银行账户进行支付的； </p>
        <p class="txin">e). 经证实用户为政府部门发布的恐怖分子或被列入其他黑名单； </p>
        <p class="txin">f). 存在其他违反诚实信用或欺诈行为的； </p>
        <p class="txin">g). 本协议变更时，您明示并通知点点不愿接受新的服务协议的； </p>
        <p class="txin">h). 您连续三年未登录过点点平台的； </p>
        <p class="txin">i). 其它点点认为应当终止服务的情况。 </p>
        <p class="txin">3.  您的会员服务被中止、终止或者账户被注销后，点点仍有权继续保存您在点点服务期间的所有交易信息。 </p>
        <p class="txin">4.  点点中止或终止向您提供点点平台上的服务或注销您的账户后，对于您在服务中止或终止之前接受或购买的点点平台上的产品和服务，点点仍将按产品或服务所对应具体协议或约定履行。 </p>

        <p class="mt20">五、法律适用、管辖与其他 </p>
        <p class="txin">1. 本协议适用中华人民共和国大陆地区法律。 </p>
        <p class="txin">2. 如因本协议产生之争议，您同意以被告住所地人民法院为第一审管辖法院。 </p>
        <p class="txin">3. 本协议包含了您成为点点会员所需要了解并遵守的协议条款，您在购买或接受点点平台上某产品或服务时还需要了解并签署该特定产品或服务的条款或具体约定（请参见您接受该产品或服务时签署的其他协议）。 </p>

        <p class="mt20 fwbd tc">保山施甸长江村镇银行隐私权政策 </p>

        <p class="fwbd mt20">概述和声明 </p>

        <p class="mt20">保山施甸长江村镇银行股份有限公司及旗下公司（以下称“保山施甸长江村镇银”或称“我们”）尊重并保护用户隐私，我们将按照本隐私权政策（以下简称“本政策”）收集、使用及共享您的个人信息。本政策包含了我们<span class="fwbd">收集、存储、保护、使用和共享您的个人信息</span>的条款，我们建议您完整地阅读本政策，以帮助您了解维护自己隐私权的方式。当您同意保山施甸长江村镇银的服务协议时，或您访问保山施甸长江村镇银的网站（如保山施甸长江村镇银行股份有限公司网及其相关网站）、移动设备客户端点点、微信公众号时，或您使用我们提供的任一服务时，代表您已在知情和同意的情况下，自愿向保山施甸长江村镇银提供您的个人用户信息。 </p>
        <p>本政策所称<span class="fwbd">“保山施甸长江村镇银行”</span>，包括： 1、保山施甸长江村镇银行股份有限公司； 2、保山施甸长江村镇银行股份有限公司直接或间接控股的公司； 3、保山施甸长江村镇银行股份有限公司参股或形成经营、协作联系的关联单位。 </p>
        <p>以上包括现有或将来设立的符合以上条件的公司主体。我们将按照本政策来收集、保护、使用、共享您的个人信息，如国家法律法规或监管规定对保山施甸长江村镇银行另行规定或您与保山施甸长江村镇银行另行约定的条款与本政策不一致的，以另行规定、约定的为准。 </p>
        <p>我们收集、使用您的信息是出于遵守国家法律法规的规定以及向您提供服务及提升服务质量的目的（包括开发新产品或完善已有产品功能；为您和其他用户提供更为优质的服务等）。若您向我们提供了本政策中列明的信息，您可使用更多保山施甸长江村镇银行的服务，和（或）享受更便捷的客户服务，和（或）避免我们无法及时与您取得联系而产生对您不利的影响等。 </p>

        <p class="fwbd mt20">一． 收集个人信息的范围：</p>
        <p class="mt20">当您访问保山施甸长江村镇银的网站、移动设备客户端及/或微信公众号时，或您使用保山施甸长江村镇银平台上提供的服务时，您会向我们主动提供一些信息，我们也会收集您的一些信息。</p>
        <p>我们收集信息的范围主要包括：</p>
        <p>1、为了遵守法律法规的要求以及向您提供更个性化、更便捷的服务，我们需要识别您的身份。例如在您注册点点APP账户或购买点点APP平台上提供的产品或者服务时，您可能要向我们提供一些个人信息，包括但不限于您的姓名、身份证明、地址、工作单位、电话号码和电子邮件地址、生物特征等信息及相关附加信息（如您所在的省份和城市、邮政编码等）。</p>
        <p>2、如您使用的保山施甸长江村镇银的服务与产品需与您的银行账户或其他支付工具的账户关联方能实现时，您需要向我们提供您的银行账户信息或其他支付工具的账户信息。</p>
        <p>3、我们同时可能会从保山施甸长江村镇银旗下公司和商业合作伙伴获得信息以补充我们自己收集的信息。 </p>
        <p>4、为了保护您的账户安全，当您访问保山施甸长江村镇银的网站或移动设备客户端时，或使用保山施甸长江村镇银提供的服务时，我们可能会记录您操作的相关信息，包括但不限于您的网络信息、设备标识符、硬件型号、操作系统版本、您的位置以及与保山施甸长江村镇银的服务相关的日志信息，这些信息可帮助我们更好地识别您的身份。</p>
        <p>5、为使您获得更轻松的访问体验，您访问保山施甸长江村镇银的网站或使用保山施甸长江村镇银平台提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。我们网站上还可能包含一些电子图象（称为“单像素GIF文件”或“网络Beacon”），使用网络Beacon可以帮助网站计算浏览网页的用户或访问某些Cookie，我们会通过网络Beacon收集您浏览网页活动的信息，例如您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定等。</p>
        <p>除上述信息外，我们还可能为了提供服务及改进服务质量的合理需要而收集您的其他信息，包括您与我们的客户服务团队联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与保山施甸长江村镇银及旗下公司互动时我们收集的相关信息、与您曾使用的移动应用（APP）和其他软件相关的信息。与此同时，为提高您使用保山施甸长江村镇银提供的服务的安全性，更准确地预防钓鱼
        网站、短信欺诈和木马病毒，我们可能会通过了解一些您的网络使用习惯、您常用的软件信息以及通过识别您短信中的欺诈内容等手段来判断您账户的风险，并可能会记录一些我们认为有风险的URL、IP地址等。</p>

        <p class="fwbd mt20">二、使用个人信息的范围：</p>

        <p>因收集您的信息是出于遵守国家法律法规的规定以及向您提供服务及提升服务质量的目的，为了实现这一目的，我们可能会把您的信息用于下列用途：</p>
        <p>1、向您提供或推荐保山施甸长江村镇银的各项服务及客户服务，并维护、改进这些服务。</p>
        <p>2、比较信息的准确性，并与第三方进行验证。例如，将您向我们提交的身份信息与身份验证的服务机构进行验证。</p>
        <p>3、为使您知晓自己使用保山施甸长江村镇银的各项服务的情况或了解保山施甸长江村镇银的服务，向您发送服务状态的通知、营销活动及其他商业性信息。</p>
        <p>4、对保山施甸长江村镇银用户的身份数据、交易信息等进行综合统计、分析或加工等处理，可能会出于销售、奖励或为了向您推荐更合适的产品或者服务而使用、共享或披露这些经过处理的信息。例如，我们可能会统计某个时间段关注某个产品或者服务的新客户，向这些新用户提供专享优惠活动。</p>
        <p>5、预防或禁止非法的活动。</p>
        <p>6、经您许可的其他用途。</p>
        <p>7、与您保持联系，包括向您寄发有关您在我们公司任何账户或本隐私声明日后变动的通讯。</p>
        <p>8、供保山施甸长江村镇银、金融服务业或我们的相关监管机构的统计或研究之用。</p>
        <p>9、供我们作资料匹配，内部业务及管理之用。</p>

        <p>10、协助执行法例、警方或其他政府或监管机构调查，以及遵守适用法律及规例所施行的规定，或其他向政府或监管机构承诺之义务。</p>
        <p>11、在收集之时所通知的其他用途。</p>
        <p>12、及与上述任何项目直接间接有关的其他用途。</p>
        <p class="fwbd mt20">三、共享个人信息的范围</p>

        <p>我们对您的信息承担保密义务，但我们有权在下列情况下将您的信息与第三方共享：</p>
        <p>1、获得您的同意或授权。</p>
        <p>2、为了向您提供或推荐服务、产品，或为了向您提供更完善的服务，或某些情况下，只有共享您的信息，才能提供您需要的服务和（或）产品，或某些服务和（或）产品由我们的合作伙伴提供或由我们与合作伙伴、供应商共同提供，我们会在保山施甸长江村镇银内部以及与包括保山施甸长江村镇银旗下公司在内的第三方共享您的相关信息。</p>
        <p>3、为了判断您的账户或交易是否安全。</p>
        <p>4、我们与第三方进行联合推广活动，我们可能与其共享活动过程中产生的、为完成活动所必要的个人信息，如参加活动的用户数、中奖名单、中奖人联系方式等，以便第三方能及时向您发放奖品。</p>
        <p>5、为维护保山施甸长江村镇银用户的合法权益。</p>
        <p>6、根据法律规定及合理商业习惯，在我们计划与其他公司合并或被其收购或进行其他资本市场活动（包括但不限于IPO，债券发行）时，以及其他情形下我们需要接受来自其他主体的尽职调查时，我们会把您的信息提供给必要的主体，但我们会通过和这些主体签署保密协议等方式要求其对您的个人信息采取合理的保密措施。</p>
        <p>7、如您授权第三方向我们查询、采集您在保山施甸长江村镇银公司的账户或保单相关信息，我们有权在法律法规允许和您的授权许可范围内向第三方分享您账户或其他相关信息。</p>
        <p>8、为了维护和改善我们的服务。</p>
        <p>9、根据法律法规的规定或有权机关的要求。</p>

        <p>除上述用途外，保山施甸长江村镇银不会将您的个人信息用于任何未经您同意的用途，不会将所接受的任何个人信息泄露、篡改、毁损、出售或者提供给任何第三方。</p>
        <p>保山施甸长江村镇银会遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。</p>
        <p>您可以提交书面请求以查阅您的个人信息，或要求对错误的信息进行更正、修改或删除。如果您的个人信息有任何变动，请通知我们以便我们保持信息更新并提供更好的服务。此外，您可以通过书面方式要求保山施甸长江村镇银从数据库中取消您所登记的任何服务并停止使用您的个人信息。</p>

        <p class="fwbd mt20">对第三方责任的声明</p>
        <p>请您注意，您的交易相对方、您访问的第三方网站经营者、您使用的第三方服务提供者和由保山施甸长江村镇银处接受您的个人信息的第三方可能有自己的隐私权保护政策；当您查看第三方创建的网页或使用第三方开发的应用程序时，可能会发现该网页或应用程序放置的Cookie或像素标签。同样，这些第三方可能会放置他们自己的Cookie或像素标签，这些Cookie或标签不受我们的控制，而且它们的使用不受本政策的约束。</p>
        <p>我们会尽商业上的合理努力去要求这些主体对您的个人信息采取保护措施，但我们无法保证这些主体一定会按照我们的要求采取保护措施，亦不对这些主体的行为及后果承担任何责任。如果您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，建议您终止相关操作以保护您的合法权益。</p>

        <p>未成年人隐私权特别约定</p>
        <p>我们重视未成年人的个人信息保护，如您为未成年人，建议您请您的监护人仔细阅读本政策，并在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。</p>
        <p>任何与您个人信息有关的请求或投诉，以及要求取消您所选取的保山施甸长江村镇银的任何服务，请发送电子邮件至：kefu@zhonglianbiz.com或者致函以下地址：深圳市南山区滨海大道3012号三诺智慧大厦25F，邮编：518000。</p>

        <p>保山施甸长江村镇银"隐私权政策"体现了我们将按照国家关于个人信息保护有关法律法规保护和管理您个人信息的承诺，我们会根据不时修订的相关法规要求更新本"隐私权政策"。我们的"隐私权政策"公布于保山施甸长江村镇银官方网站，方便您随时查阅。</p>
        <p class="fwbd mt20 tc txdr">点点平台授权及协议须知</p>
        <p class="fwbd txdr txin mt20">申请使用“点点平台服务”，您需要详细阅知并同意本须知及相关协议的所有内容，如您不同意相关协议的任何条款，请停止使用“点点平台”服务：</p>
        <p class="fwbd txdr txin">1.您使用“点点平台”服务，须与保山施甸长江村镇银行股份有限公司（以下简称服务商）和 在线财产保险股份有限公司(以下简称  )签订《“点点平台”用户服务协议》，并授权 向中国人民银行及其他合法征信机构(以下合称“征信机构”)查询您的个人信用信息，用于评估服务商与您的交易条件和控制服务中的风险。</p>
        <p class="fwbd txdr txin">2、有效期至您实际与“点点平台”服务商签订的《“点点平台”用户服务协议》规定的双方权利义务完全终止之日止。</p>
        <p class="fwbd txdr txin">3、服务商将根据您的授权及委托，即对您的用户信息进行采集、整理、加工、保存，并向征信机构提供该等用户信息或基于该等用户信息加工、整理的信息，征信机构结合该等信息与其他因素，自行判断您的信用水平和/或相关风险，从而将输出结果告知服务商，由服务商决定其与您的交易条件或做出其他与您使用本服务相关的决策，具体的个人信用信息查询及结果反馈形式以实际提供的为准。</p>
        <p class="fwbd txdr txin">4、为了保护您的合法权益，服务商不会采集您(作为个人用户)的宗教信仰、基因、指纹、血型、疾病和病史信息以及法律、行政法规规定禁止采集的其他个人信息。</p>
        <p class="fwbd txdr txin">5、服务商将根据您的授权及委托，直接或指定合作的第三方支付清算公司 (以下简称第三方支付机构)或银行从您的任何一个或多个资金账户(包括但不限于点点平台账户、与点点平台账户绑定的储蓄卡账户等各类账户)中扣除相应款项用于偿还您在服务项下到期债务（包括但不限于应付账款本金、逾期违约金等），直至债务清偿完毕为止，具体授权内容见《“点点平台”服务扣款授权书》</p>


        <p class="fwbd mt20 tc txdr">“点点平台”用户服务协议</p>

        <p class="fwbd mt20 txdr">合同编号：</p>
        <p class="fwbd mt20 txin txdr">特别提醒：在您确认签署本协议之前，请您务必仔细阅读本协议所有条款，尤其是以粗体或下划线标准的条款，签署条款含有免除或限制协议其他方责任的内容。一旦您点击“同意”、“立刻开通”、“确认”等表示认可的按钮确认使用“点点平台”用户服务(以下简称“本服务”)，即意味您已充分理解本协议所有条款的含义及相应的法律后果，同意与本协议其他方通过网络订立本协议并接受本协议约束。本协议的缔约方除您之外，其他方包括：保山施甸长江村镇银行股份有限公司（以下简称服务商）、 在线财产保险股份有限公司。</p>

        <p class="fwbd mt20">第一条 基本信息</p>

        <p class="mt20">为了保护您的个人信息，本协议在向您展示时将部分隐藏您的部分身份信息，您的身份信息以您的【点点平台账户】对应的实名信息为准。</p>

        <p class="mt20">用户姓名：【】</p>
        <p>身份证号码：【_*****************_】</p>
        <p>联系方式：【】</p>
        <p>协议生效要件：本协议自【您首次开通本服务/服务商审核通过】之时生效。</p>

        <p class="fwbd mt20">第二条 术语定义</p>

        <p>除非本协议正文另有明确所指，在本协议中所用下列术语定义如下：</p>

        <p>1.  <span class="fwbd">用户</span>：指在“点点平台”上开设实名认证账户，且符合现金贷使用规则及本协议要求，使用本服务的自然人，以下称“您”或“用户”。
        <p>2.   <span class="fwbd">资金方</span>：为点点平台服务提供借款资金的第三方。
        <p>3.   <span class="fwbd">“点点平台”服务或本服务</span>：指服务商向您提供的用于借款的相关金融服务。服务商有权不时调整该服务的营销推广名称。若营销推广名称有所调整，以点点平台官方APP公布的为准，不影响本协议的有效性和对各方的约束。
        <p>4.   <span class="fwbd">“点点平台”账户</span>：指您根据与服务商签订的《用户注册协议》，注册并认证成功后取得的实名认证账户。
        <p>5.   <span class="fwbd">最高承保额度</span>：指根据您的基本信息由 对您的信用情况进行审核后， 对您使用现金贷借款额所产生的个人消费贷款本息可进行承保的最高额度。
        <p>6.   <span class="fwbd">分期本金</span>：指您使用“点点平台”服务对应的分期金额合计。</p>
        <p>7.   <span class="fwbd">到期还款日</span>：指您应将当月分期金额全部还清的最晚日期。如您未能最迟于到期还款日全额清偿当期全部应还款金额，将视为您逾期。</p>
        <p>8.   <span class="fwbd">应还款金额</span>：指您在提交还款时应支付的全部金额，包含分期本金、分期应还款项（如有）、利息、逾期违约金(如有)和其他款项(如有)的金额总额。</p>
        <p>9.   <span class="fwbd">逾期违约金</span>：指在您未能于到期还款日前支付全部到期应还款而导致违约时，服务商有权在向资金方赔付后按日就您当期仍未清偿的应还款项收取的违约金，直至您的到期应还款清偿完毕。</p>
        <p>10.  <span class="fwbd">用户个人信息</span>：指您在申请开通及使用“点点平台”服务时依据网站要求所提供的法律规定的个人身份信息，包括但不限于姓名、证件号、联系地址、手机号码等。</p>


        <p class="fwbd mt20">第三条 个人消费贷款信用保险</p>

        <p class="txin fwbd mt20">该保险为 推出的一款互联网信用保险产品，针对您的个人消费贷款需求，为您提供方便快捷的保险服务。您作为借款申请人在申请借款成功后，资金方作为投保人和被保险人向 为该笔借款投保个人消费贷款信用保险，如您在规定期限内未履行还款义务，则 将您未履行还款义务部分的损失赔付给资金方， 在赔付完成后有权就赔付款项向您进行追偿。并且， 有权向中国人民银行征信系统及其他合法征信机构披露您的相关信息。</p>
        <p class="fwbd mt20">第四条 服务费</p>

        <p class="txin fwbd mt20">1.  在您使用本服务时，资金方有权向您收取服务费用。服务费按照消费本金的一定比例收取，根据分期的期数不同，手续费收取比例不同。</p>
        <p class="txin fwbd">2.  逾期利息：无论分期还款还是全额还款，若您在到期还款日仍未清偿当月应还的消费本金及当月分期应还款项，资金方将按每日未偿消费本金和及当月分期应还款项的余额的一定比例逐日计收逾期利息，直至您的消费本金及当月分期应还款项清偿完毕。在服务商向资金方赔付后，服务商即取得对您的代位追偿权，有权向您收取前述逾期利息。</p>

        <p class="fwbd mt20">第五条 还款</p>

        <p class="txin fwbd mt20">(一) 还款方式</p>

        <p class="txin">1.  使用“点点平台”服务申请借款成功后，应当在到期还款日23：00点前完成应还款金额支付。</p>
        <p class="txin">2.  您偿还应还款金额时可在“点点平台”进行操作。</p>
        <p class="txin">3.  若您未能在到期还款日23：00点前支付全部应还款金额而导致逾期时，资金方或“点点平台”有权自到期还款日次日起向您按日收取逾期违约金。</p>

        <p class="txin fwbd mt20">(二) 还款提醒</p>

        <p class=""<p>>【服务商】可在到期还款日前以向您的手机号码发送短信、站内信、自动电子语音、人工电话提醒等形式提醒您按时还款。</p>


        <p class="fwbd mt20">第六条 违约及违约处理</p>

        <p class="mt20">(一) 违约情形</p>

        <p class="mt20">您发生下列任一情况，均构成违约：</p>

        <p>1.  您未按本协议规定按时足额支付应还款金额。</p>
        <p>2.  您向服务商提供任何过期或虚假的信息或任何信息被服务商认为是可疑、过期或虚假信息。</p>
        <p>3.  您被宣告失踪、宣告死亡、处于限制民事行为能力或丧失民事行为能力状态、承担刑事责任。</p>
        <p>4.  您发生重大疾病、重大事故等可能影响付款能力的情况。</p>
        <p>5.  您以任何方式允许或者默许本人之外任何其他方使用“点点平台”服务。</p>
        <p>6.  您的资信情况出现其他重大不利变化导致您无法继续按时足额支付应付款的情形。</p>
        <p>7.  您存在欺诈行为的。</p>
        <p>8.  违反本协议约定的其他义务。</p>

        <p class="mt20 fwbd">(二) 违约处理</p>

        <p class="mt20 fwbd">如出现上述违约情形，或违背本协议项下其他任何义务、陈述、保证或承诺的，服务商有权采取下列一项或多项措施，包括但不限于：</p>

        <p class="fwbd mt20">1.  调整或取消您的最高承保额度。</p>
        <p class="fwbd">2.  要求您限期纠正违约行为。</p>
        <p class="fwbd">3.  中止或终止向您提供“点点平台”服务或其他相关服务。</p>
        <p class="fwbd">4.  宣布本协议及“点点平台”服务项下未支付的应还款金额提前到期，并要求您提前支付全部应付款项。</p>
        <p class="fwbd">5.  通知**银行或第三方支付机构从您绑定的储蓄卡账户中扣收全部或部分应付款项。如果账户中款项的币种与分期本金发放的币种不同，服务商有权按扣款当日中国人民银行公布的外汇中间价折算成应付款项币种。</p>
        <p class="fwbd">6.  扣划您在服务商或服务商关联公司处的任何应收或留存款项（如有）用以偿还您在服务商处的债务。</p>
        <p class="fwbd">7.  以合法手段追偿应付款项(包括但不限于委托债务催讨公司、律师事务所等其他第三方代为追讨，申请相关部门进行调查、向法院提起诉讼等)，由此引起的一切费用由您承担。</p>
        <p class="fwbd">8.  根据法律法规或本协议约定有权采取的其他违约救济措施。</p>

        <p class="fwbd mt20">第七条 权利和义务</p>

        <p class="fwbd mt20">(一) 用户的权利和义务</p>

        <p class="mt20">1.  有权要求服务商对您提供的有关信息予以保密，但法律法规另有规定、您予以授权、或本协议另有约定的除外。</p>
        <p>2.  享有服务商对“点点平台”服务所承诺的各项服务，有权监督服务质量，并对不符合质量的服务进行投诉。</p>
        <p>3.  有权知悉“点点平台”服务的功能、使用方法、收费项目、收费标准、适用费率及相关的计算规则。</p>
        <p>4.  向【服务商】提供真实、有效的资料。如迁往异地、工作变动、通讯地址及电话变更、单位名称变更、电子邮箱或身份证件号码变更等，应及时通知服务商，包括但不限于登陆账户修改、书面通知、在线或电话联系客服等。</p>
        <p>5.  仔细阅读并充分理解本协议、重要提示及其他所有相关资料和文件，并持续关注服务商通过网站等方式向您公示的协议修订，以及对上述资料和文件的修改和变更。</p>
        <p>6.  应妥善保管本人的账户名、密码、绑定的手机号码、手机校验码等与服务商有关的一切信息。您应确保不向其他任何人泄露账户信息和密码。对于因密码泄露所致的损失，由您自行承担。如您发现有他人冒用或盗用本人账户及密码或任何其他未经合法授权之情形时，应立即以有效方式通知服务商，要求其暂停相关服务。同时，您理解服务商对相应的请求采取行动需要合理期限，在此之前，服务商对已执行的指令及(或)所导致的您的损失不承担任何责任。</p>
        <p class="fwbd">7.  您了解并同意，“点点平台”与资金方提供上述资金划转服务时可能需要与银行或非银行业的第三方支付机构等开展合作。因此，您确认并同意：“点点平台”和资金方不对银行及第三方支付机构进行相应资金划转的时限、准确性、及时性等作出任何承诺或承担任何相关责任，包括但不限于由此产生的利息、货币贬值、银行及第三方支付机构系统故障、银行及第三方支付机构对资金划转的特定限制等导致的损失或责任。</p>
        <p>8.  您应按时支付“点点平台”服务项下的应付款项。</p>
        <p>9.  您知晓并确认，如逾期向资金方还款的，则 有权在向资金方承担保险责任后向您追偿以下款项（简称“追偿款项”）：</p>
        <p>a)   理赔的全部款项；</p>
        <p>b)  用户逾期还款产生的逾期利息、逾期违约金；</p>
        <p>c)   为追偿、催收上述款项所产生的其他一切费用（包括但不限于评估鉴定费、差旅费、诉讼费、执行费、律师费等）。</p>
        <p>10. 按照服务商制订并公布的收费标准支付相关费用。</p>
        <p>11. 如您发生对您财务情况构成威胁或对您履行本协议项下的义务产生不利影响的任何其他事件，包括但不限于涉及或可能涉及经济纠纷、财务状况恶化等，均应在该等情形发生之日起五个工作日内书面通知服务商。</p>
        <p>12. 您声明在接受本协议时本人不存在任何违反法律、法规与规章的行为或情形；若您的上述声明虚假或者上述承诺未被履行，或者您可能发生违法违规风险，服务商有权提前终止本服务或采取本协议约定或法律允许的其他救济措施。</p>
        <p>13. 在您未清偿所有应付款项前，您不得提前终止本协议；且您同意在您未清偿所有应付款项前，若申请变更、注销您的任何一个账户，均应事先征得服务商的同意。</p>
        <p>14. 如您已归还应付款项或以其它方式消除违约情形的，您愿意自行督促服务商及时通知服务商关联公司删除相关违约信息或恢复您与服务商关联公司相关服务协议的履行，以免因服务商关联公司无义务接受来自您的任何通知而造成您的困扰。</p>

        <p class="fwbd mt20">(二) 服务商的权利和义务</p>

        <p class="mt20">1.  对不遵守有关法律法规、本协议等规定的用户(包括但不限于用户未在规定期限内支付应付款项的)或者服务商有理由认为用户不再符合“点点平台 ”服务的使用条件时，服务商有权基于合理怀疑拒绝用户继续使用“点点平台”进行付款，并由“点点平台”以本协议中规定方式提醒您，如您在合理期限内未向服务商提供充分证据以消除该等合理怀疑的，服务商有权提前暂停“点点平台”服务而不必事先通知您本人。您对服务商网站停止其“点点平台”服务的使用有异议的，需要按照服务商的要求，依据服务商网站所提供的用户服务等方式向服务商提供充分证据以消除该等合理怀疑，具体异议提出方式及解决方式以服务商不时发布和更新的规则约定为准。</p>
        <p>2.  服务商保留对您收取费用的权利，且有权在有关法律法规允许的范围内，结合“点点平台”业务发展等实际情况，不时地维护和更新“点点平台”服务的适用范围、各项使用功能、服务范围和收费标准，并以本协议约定的方式及时通知您。</p>
        <p>3.  服务商将根据行业规则、国家相关法律法规及业务发展情况为您提供相关的优惠活动或服务，活动或服务规则以届时服务商相关页面公布的内容为准。</p>
        <p>4.  服务商将通过服务商网站公告、站内消息、电子邮件、手机短信等您在服务商网站已经认可的信息推送方式向您公示和/或告知以下信息和通知：</p>
        <p>a)  新的服务、机会以及优惠信息；</p>
        <p>b)  “点点平台”服务的适用范围、各项使用功能、服务范围和收费标准，以及其不时地修订和更新；</p>
        <p>c)  本协议有关的服务信息、重要提示、协议文件；</p>
        <p>d)  其他与本协议有关的信息和通知。</p>
        <p>5.  服务商有义务接受您对于“点点平台”服务相关信息的查询服务。服务商有建立针对“点点平台”服务的公平、有效的投诉制度的义务，并公开投诉程序和投诉电话。对您关于账务情况的查询和改正要求给予答复。</p>
        <p>6.  服务商对您的个人身份信息以及与您有关的银行卡等数据(以下简称“保密信息”)有权予以保留，服务商对该等保密信息负有保密的义务，除与履行本协议有关的合作公司、或出于为您提供更好的服务目的以外，未经您的允许，服务商不得擅自将该等保密信息以任何形式披露给第三方，但根据相关法律法规需予以披露或者依据本协议的规定使用、披露用户信息的除外(包括：服务商对您的违约情形进行违约救济，服务商向人行征信系统提供用户相关信息等情形)。</p>
        <p>7.  服务商有权采取以下措施督促您尽快履行还款义务，包括但不限于将您列入其及其合作方所对接的征信系统黑名单、通过您提供的信息进行催收、通过第三方合作机构催收借款等。</p>

        <p class="fwbd mt20">第八条 用户信息的提供、收集、使用</p>

        <p>您同意按照以下要求提供基本信息：</p>

        <p>1.您的基本信息的收集范围以“点点平台”服务实名认证的要求为准。您应及时提供申请服务所需的各项信息，并应确保提供的信息真实、完整、准确。
        <p>2.  如因您违反上述规定，提供的信息不真实、不完整、不准确、不及时，所造成的一切损失和责任由您承担，服务商有权立即停止为您提供服务并视情况限制或禁止您使用本产品的全部或部分功能。</p>
        <p>3.  您同意授权服务商收集、保存、使用、管理、披露您的个人资料、信息、档案（包括但不限于您的个人身份证信息、联系地址、联系方式、学历信息、历史交易记录、信贷信息等），同意授权服务商和通过其合作的第三方机构核实该等资料和记录（包括但不仅限于人行征信、腾讯征信、芝麻信用等）。</p>
        <p>4.  您同意服务商按照如下规则使用及公开您的信息：</p>
        <p class="txin">a)  为促成您与服务商签署本协议之目的，服务商有权在相互之间互通和共享您的信息，以便在作出是否签署本协议、确定具体承保额度或是否向您提供或终止服务的决定时参考。</p>
        <p class="txin">b)  如您违反本协议约定，服务商有权在相互之间使用您的信息以向您催收债务；同时服务商有权将您的逾期信息在不违反中国法律的情况下向第三方合作机构提供，以促使您履行本协议。</p>
        <p class="txin">c)  在行政、司法等政府机构要求时，服务商可向此类机构提供您的信息。例如涉及“反洗钱”要求的，服务商可根据此类机构的要求提供用户的身份证复印件及其他身份识别文件。</p>
        <p class="txin">d)  服务商按照本条规定使用您信息的，无需对因获取、使用、公开您信息而给您造成的任何损失承担独立的或连带的赔偿责任，包括但不限于因服务商或第三方合作机构的不当使用您信息的行为给您造成的任何损失。</p>

        <p class="fwbd mt20">第九条 通知和送达</p>

        <p class="fwbd mt20">(一) 通知</p>

        <p>除法律法规或监管规定另有强制性规定外，本协议履行过程中，服务商传递给您的书面通知，按照您向服务商提供的通讯地址交邮后的第三个自然日即视为送达；书面通知的形式还包括但不限于在服务商公告、向您发送电子邮件、站内消息、手机短信和传真等电子方式，在采用电子方式进行书面通知的情况下发送当日即视为送达。</p>

        <p class="fwbd mt20">(二) 司法文书送达</p>

        <p>对于因本协议引起的任何诉讼中的司法文书(包括但不限于诉讼文书)，同意司法机关通过向您在本协议中约定的指定账户中留存的通讯地址和/或手机号码送达法律文书和/或发送短信的方式予以送达，司法机关向前述通讯地址和/或手机号码发出法律文书和/或短信当日即视为送达，且上述送达方式适用于各个司法阶段，包括但不限于一审、二审、再审、执行以及督促程序。</p>

        <p class="fwbd mt20">(三) 通讯地址和信息</p>

        <p>您确认及保证通讯地址和信息是真实、准确、有效的。若您的送达地址有变更，您有义务及时告知服务商和/或司法机关变更后的送达地址。如果提供的通讯地址和信息不确切，或未能及时告知变更后的通讯地址和信息，您自行承担由此可能产生的法律后果。</p>

        <p class="fwbd mt20">第十条 免责条款</p>

        <p class="fwbd mt20">(一) 免责</p>

        <p>服务商网站及与提供“点点平台”服务相关平台的信息系统出现下列任一状况而无法正常运作，致使无法向您提供本协议项下的各项服务，服务商不承担任何违约或赔偿责任，该状况包括但不限于：</p>

        <p>1.  在“点点平台”服务网站维护期间；</p>
        <p>2.  电信设备出现故障不能进行数据传输的；</p>
        <p>3.  因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成系统障碍不能执行业务的；</p>
        <p>4.  由于黑客攻击、电信部门和其他服务商有信息技术依赖的相关部门、企事业单位技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。</p>

        <p class="fwbd mt20">(二) 法律、政策变更</p>

        <p>本协议有效期内，因国家相关主管部门颁布、变更的法令、政策导致服务商不能提供约定服务的，不视为其违约，各方可根据相关的法令、政策变更协议内容或提前终止本协议，在此情况下，您已经使用“点点平台”服务而尚未到期或偿还的任何款项(包括服务费和其他费用)，视为立即到期，您应立即归还，否则服务商仍有权按照本协议的约定采取合理的救济措施。</p>

        <p class="fwbd mt20">第十一条    协议变更、解除、终止和权利义务的转让</p>

        <p class="fwbd mt20">(一) 协议变更与解除</p>

        <p>1.  您在此不可撤销地同意，服务商有权随时单方面修改或新增本协议及其有关法律文件中与您之间相关的权利义务，并及时以网站公告的方式通知您。经修订的协议自服务商发布网站公告之日起立即生效。若您不同意修改本协议，则应当立即停止使用“点点平台”服务并在服务商要求的期限内全额支付本协议项下全部应付款项；否则，视为您同意并接受修改后的协议。</p>
        <p>2.  本协议生效后，除另有书面约定外，您不得要求单方擅自变更或解除本协议。服务商有权基于自身经营考虑，因任何理由随时宣布中断、终止本协议或其任何部分，并要求您在指定期限内支付本协议项下全部应付款项。</p>

        <p class="fwbd mt20">(二) 服务终止</p>

        <p>您在使用“点点平台”服务的过程中，如果有下列情形发生，您同意服务商有权终止提供服务，您应立即支付所有到期和未到期的应付款项：</p>

        <p>1.  您主动关闭“点点平台”服务；</p>
        <p>2.  您个人账户被注销；</p>
        <p>3.  冒用他人名义、盗用他人账户使用“点点平台”服务；</p>
        <p>4.  您违反本协议或与本协议相关的任何规范性文件的约定导致本协议中约定的违约情形出现的；</p>
        <p>5.  从事司法机构、监管机构等认为违法违规的交易行为，或“点点平台”服务提供方认定的不适当交易行为；</p>
        <p>6.  除上述原因外，服务商有权根据风险及自身业务运营情况需要随时中止或终止向您提供“点点平台”服务，因此导致您无法使用服务或服务受到限制的，不视为“点点平台”服务提供方违约，在此情况下，您已经使用“点点平台”服务而尚未到期或偿还的任何款项(包括本金、逾期违约金和其他费用)，视为立即到期，应立即归还。</p>

        <p class="fwbd mt20">(三) 权利义务的转让</p>

        <p>未经服务商事先书面同意，您不得将本协议项下的权利和义务全部或部分地转让给任何第三方。服务商有权将其在本协议项下的权利和义务全部或部分转让给第三方，且转让行为无须征得您的同意，服务商将书面通知您该等转让行为。</p>

        <p class="fwbd mt20">第十二条    附则</p>

        <p class="fwbd mt20">(一) 争议解决</p>

        <p>因本协议引起的或与本协议有关的争议，您可与服务商协商解决。协商不成的，任何一方均有权提交上海仲裁委员会以仲裁的方式进行解决。</p>

        <p class="fwbd mt20">(二)其他</p>
        <p>本协议未尽事宜，以相关法律法规及修改或新增的相关协议、“点点平台”服务项下服务商委托的第三方的相关服务协议及其他平台规则约定为准。</p>
    </article>
</template>

<script>
    export default {
        beforeRouteEnter (to, from, next) {
            document.title = '点点会员服务协议'
            next()
        }
    }
</script>



// WEBPACK FOOTER //
// xhcd.vue?6d61729c